import { enableProdMode, NgModuleRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import moment from 'moment-timezone';

import { AUTH_METHOD, AUTH_TOKEN, NoopNgZone } from '@recruitee/common';
import { patchMoment } from '@recruitee/i18n';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { authService, authStrategy } from './main-deps';

import './vendor';

// @ts-ignore
window['moment'] = moment;
require('moment/locale/de');
require('moment/locale/nl');
require('moment/locale/fr');
require('moment/locale/fi');
require('moment/locale/sv');
patchMoment(moment);
moment.locale('en');

if (environment.production) {
  enableProdMode();
}

const getAuthToken = async (): Promise<string | void> => {
  try {
    return await authService.getAccessToken();
  } catch (err) {
    console.warn(`~~~~~~ getAccessToken ERROR ~~~~~~`);
    console.error(err);
  }
};

const bootstrap = async () => {
  const authToken = await getAuthToken();

  if (!authToken) {
    authStrategy.onAuthorizationFailed();
  }

  const ngModule: NgModuleRef<any> = await platformBrowserDynamic([
    { provide: AUTH_TOKEN, useValue: authToken },
    { provide: AUTH_METHOD, useValue: 'Bearer' },
  ]).bootstrapModule(AppModule, {
    ngZone: new NoopNgZone(),
  });

  return ngModule;
};

bootstrap();
